import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    paddingTop: "0px !important",
    "@media (orientation: landscape)": {
      height: "100% !important",
    },
  },
  content: {
    textAlign: "center",
    marginTop: theme.spacing.space24,
  },
  label: {
    marginTop: theme.spacing.space12,
    marginBottom: theme.spacing.space8,
  },
  logo: {
    height: 100,
    width: 100,
  },
}));
